import { Product, ProductSlug } from "@/api/product-api";
import { ProductUtil } from "@/utils/ProductUtil";

/**
 * **한정판** — 재고가 다 팔리면 다시 들어오지 않는 제품.
 *
 * 일반 제품은 품절이어도 목록 · 상세에 남고 「Sold Out」 + 재입고 알림을 띄운다(재입고되므로). 한정판은 재입고가 없어
 * 그 화면이 거짓 안내가 된다 → **품절이면 판매 목록 · 홈 팝업에서 빼고, 상세 페이지는 제품 목록으로 보낸다**.
 *
 * - EXOSHOCK 번들: 행사 기간 = 조끼(TactSuit Air: Onyx 메시 한정) 재고 소진까지, 남은 게임 키는 게임사에 반납
 *   (기획 2026-11-03). 사이트는 **번들 SKU 재고**(mgmt `skuOptions[].stock`)만 본다 — 어드민의 번들 재고를 조끼 수량에 맞춘다.
 */
export const LIMITED_EDITION_SLUGS: readonly string[] = [
  ProductSlug.EXOSHOCK_BUNDLE,
];

/**
 * 한정판이고 모든 SKU 재고가 0 이하인가 — 품절 판정은 기존 `ProductUtil.isProductSoldOut` 그대로.
 *
 * ⚠️ SKU 가 없으면(`[]` · 누락) **품절로 보지 않는다** — `[].every(...)` 는 `true` 라 그대로 두면 데이터가 비어 온
 * 순간 한정판이 통째로 사라진다. 모르는 것은 숨기는 쪽이 아니라 기존 화면 쪽으로 둔다(구매는 장바구니 · 결제의 재고 확인이 막는다).
 */
export function isSoldOutLimitedEdition(
  product: Pick<Product, "slug" | "skuOptions"> | null | undefined,
): boolean {
  if (!product || !LIMITED_EDITION_SLUGS.includes(product.slug)) return false;
  if (!Array.isArray(product.skuOptions) || product.skuOptions.length === 0)
    return false;
  return ProductUtil.isProductSoldOut(product as Product);
}
